export const CONTACT_FORM_FIELD = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  COMPANY_NAME: 'companyName',
  PRIMARY_EMAIL: 'primaryEmail',
  PRIMARY_PHONE: 'primaryPhone',
  LIFECYCLE_STAGE: 'lifecycleStage',
  PREFERRED_CONTACT_METHOD: 'preferredContactMethod',
  TYPE: 'type',
};

export const FIRST_NAME_MAX_LENGTH = 100;
export const LAST_NAME_MAX_LENGTH = 100;
export const COMPANY_NAME_MAX_LENGTH = 100;
